import React from 'react'
import Field from '../../form/field/Field'
import './MembersSelector.less'
import { IMembersSelectorMembers } from '../MembersSelectors.types'
import { SelectedMemberRows } from './SelectedMemberRows'
import { MemberSelectorAutocomplete } from './MemberSelectorAutocomplete'
import { WithMembersSelectorContext } from './WithMembersSelectorContext'
import { InputMember } from './InputMember'
import { AddressBook } from './AddressBook'

type MembersSelectorProps = {
  isSearching: boolean
  addressBook?: IMembersSelectorMembers
  membersFound: IMembersSelectorMembers
  selectedMembers: IMembersSelectorMembers
  changeSelectedMembers: (state: IMembersSelectorMembers) => void
  onQueryChange: (query: string) => void
  inputRef?: (input: HTMLInputElement) => void
  getSelectedMembersRef?: React.RefObject<() => IMembersSelectorMembers>
}

export const NewMembersSelector: React.FC<MembersSelectorProps> = ({
  onQueryChange,
  changeSelectedMembers,
  selectedMembers,
  addressBook,
  isSearching,
  inputRef,
  membersFound
}) => (
  <WithMembersSelectorContext
    onQueryChange={onQueryChange}
    changeSelectedMembers={changeSelectedMembers}
    selectedMembers={selectedMembers}
    addressBook={addressBook}
    membersFound={membersFound}
  >
    <div className="MembersSelector">
      <Field stretch>
        <InputMember inputRef={inputRef} />
        {!!addressBook && <AddressBook />}
      </Field>

      <MemberSelectorAutocomplete isSearching={isSearching} />

      <SelectedMemberRows />
    </div>
  </WithMembersSelectorContext>
)
